var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 30,
    viewBox: "0 0 26 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.757593 1.22413C0.462412 1.56942 0.265625 2.11202 0.265625 2.75328V27.0717C0.265625 27.7622 0.462412 28.2555 0.757593 28.6008L0.855987 28.6995L14.4343 15.0851V14.9371V14.7892L0.80679 1.1748L0.757593 1.22413Z",
    fill: "#85C8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9607 19.673L14.4346 15.1349V14.9869V14.8389L18.9607 10.3008L19.0591 10.3501L24.4215 13.4084C25.9466 14.2963 25.9466 15.7268 24.4215 16.5654L19.0591 19.6237L18.9607 19.673Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.059 19.6236L14.4345 14.9868L0.757812 28.6998C1.24978 29.2424 2.08613 29.2917 3.02087 28.7491L19.059 19.6236Z",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.059 10.3007L3.02087 1.17512C2.08613 0.632518 1.24978 0.681845 0.757812 1.22445L14.4345 14.9375L19.059 10.3007Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 23.4254,
    y1: 14.9598,
    x2: -3.13631,
    y2: 14.9598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6DF33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1941,
    stopColor: "#F0CD33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5469,
    stopColor: "#E8B132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8279,
    stopColor: "#E4A030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E29A2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 16.5322,
    y1: 17.4854,
    x2: -8.51646,
    y2: 42.4678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D04749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AA1E6A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: -8.56153,
    y1: -12.7272,
    x2: 11.8901,
    y2: 7.67025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E9D71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3168,
    stopColor: "#72A970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7398,
    stopColor: "#86B96E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EC06E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.24bfed52c4bcd9b379be35c3a654c1cc.svg";
export { ForwardRef as ReactComponent };